import { api } from './serverClient';

export async function listSavedDecks(_game = 'sorcery') {
  try {
    const decks = await api.get('/decks');
    return Array.isArray(decks) ? decks : [];
  } catch (err) {
    console.error('[deckStorageApi] listSavedDecks failed:', err);
    return [];
  }
}

export async function loadSavedDeckById(deckId, _game = 'sorcery') {
  try {
    return await api.get(`/decks/${encodeURIComponent(deckId)}`);
  } catch (err) {
    if (err.message?.includes('404')) return null;
    console.error('[deckStorageApi] loadSavedDeckById failed:', err);
    return null;
  }
}

export async function saveSavedDeck(deck, _game = 'sorcery') {
  return await api.post('/decks', deck);
}

// Rename only. The server keeps the stored cards and game mode for
// fields the payload omits.
export async function renameSavedDeck(deckId, name) {
  return await api.put(`/decks/${encodeURIComponent(deckId)}`, { name });
}

// Which card art the deck tile shows. `showcase` is
// `{ cover: cardId|null, cards: [cardId|null x3] }`; null slots keep
// the default pick (avatar art / rarest cards).
export async function saveDeckShowcase(deckId, showcase) {
  return await api.put(`/decks/${encodeURIComponent(deckId)}/showcase`, { showcase });
}

// Pin/unpin a deck. Favorited decks sort to the top of the collection.
export async function setDeckFavorite(deckId, favorite) {
  return await api.put(`/decks/${encodeURIComponent(deckId)}/favorite`, { favorite });
}

// Replace a deck's tag list. Doesn't bump updated_at server-side;
// tagging is organization, not an edit.
export async function setDeckTags(deckId, tags) {
  return await api.put(`/decks/${encodeURIComponent(deckId)}/tags`, { tags });
}

// Strip a tag from every deck the player owns (the manage-tags
// "delete tag" action; tags exist only on decks).
export async function deleteDeckTag(tag) {
  return await api.delete(`/decks/tags/${encodeURIComponent(tag)}`);
}

export async function deleteSavedDeckById(deckId, _game = 'sorcery') {
  return await api.delete(`/decks/${encodeURIComponent(deckId)}`);
}
